import React from 'react';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import API from "../../Services/BaseService";
import { useHistory, useLocation, useParams } from "react-router-dom";
import CommonPopup from '../../Component/CommonPopup/CommonPopup';
import checkImg from '../../assets/img/check.svg';
import errorImg from '../../assets/img/erroricon.png';
import "../../Component/CommonPopup/commonPopup.css"
import { useEffect } from 'react';
import ErrorPopup from '../FallBackUI/ErrorPopup';
import Loading from '../../Component/Loading/Loading';
import { Button } from 'antd';
import Modal from 'react-bootstrap/Modal';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';

const SealedBid = (props) => {
  console.log("check the props in seal bid", props)
  const sellerData = useSelector(state => state.LoginReducer.payload);
  const dealerData = useSelector(state => state.DealerReducer.payload);
  // const { backURL, id,sellerDealersId } = props.location.state;
  // console.log("checking 123",id,sellerDealersId)
  const history = useHistory();

  const [historyDetails, setHistoryDetails] = useState([]);
  const [loading, setLoading] = useState(true);
  const [bidLists, setBidLists] = useState("");
  const [flag, setFlag] = useState(false);
  const [carAcceptFlag, setcarAcceptFlag] = useState(true);
  const [alertmessage, setAlertMessage] = useState("");
  const [alerttitle, setAlertTitle] = useState("");
  const [alertimg, setAlertImg] = useState("");
  const [toggleAcceptPopupOpen, setToggleAcceptPopupOpen] = useState("1");

  const [errors, setErrors] = useState("");
  const [errorFlag, setErrorFlag] = useState(false);

  const [selectedBuyerId, setSelectedBuyerId] = useState("");
  const [selectedBuyerDealerId, setSelectedBuyerDealerId] = useState("");
  const [selectedBid, setSelectedBid] = useState("");
  const [transportationCharge, setTransportationCharge] = useState("");

  const getbidsList = (data) => {

    let request = {
      car_id: props.carId,
      seller_id: sellerData.seller_id,
      seller_token: sellerData.seller_token,
    }
    API.post("sealedbidinfo/condition", request).then(response => {
      if (response.data.success === true) {


        setBidLists(response.data.data);
        setLoading(false);

      }

      else {
        setErrors(response.data.error.name)
        setErrorFlag(true)

      }


    })
      .catch(function (error) {
        if (error.response) {
          setErrors(error.response.data.error)
          setErrorFlag(true)
          setLoading(false);

        }
      });
  }

  // const bidsList=()=>{
  //   let request = {
  //             car_id : props.historycarId,
  //             seller_id:sellerData.seller_id,
  //             seller_token:sellerData.seller_token ,
  //   };
  //   const state = API.post('seller_list/condition', request);
  //   state.then(res => {
  //       console.log("res", res.data.data)
  //       if (res.data.success === true) {
  //           setBidLists(res.data.data);

  //           // setLoading(false);
  //       }
  //       else {
  //           setErrors(res.data.error)
  //           setErrorFlag(true)
  //       }

  //   })
  //       .catch(function (error) {
  //           if (error.response) {
  //               setErrors(error.response.data.error)
  //               setErrorFlag(true)
  //               setLoading(false);
  //           }
  //       });
  // }
  useEffect(() => {
    // handleCarHistory();
    getbidsList();
  }, []);

  const soldredirectpage = () => {
    setToggleAcceptPopupOpen("3")
    history.push({
      pathname: "/soldcardetails",
      state: { backURL: "/carList", id: props.carId, },
    });
  }

  const handleData = (buyerId, buyDealerId, bid, transportationcharge) => {

    setSelectedBuyerId(buyerId)
    setSelectedBuyerDealerId(buyDealerId)
    setSelectedBid(bid)
    setTransportationCharge(transportationcharge)

  }

  const handleAccepts = () => {
    let request = {
      seller_dealer_id: props.sellerDealersId,
      seller_id: sellerData.seller_id,
      active: 1,
      car_id: props.carId,
      // email:userName,
      // email:sellerData.email,
      //  password:password,
      buyer_dealer_id: selectedBuyerDealerId,
      buyer_id: selectedBuyerId,
      updatedBy: sellerData.seller_id,
      createdBy: sellerData.seller_id,
      status: "sold",
      price: selectedBid,
      buying_proccess: "Sealed Bid Sales",
      seller_token: sellerData.seller_token,
      transportation_charge: transportationCharge
    }
    console.log("Save Search Request : ", request);
    // return
    API.post("SealedBidcarbuy/update", request).then(response => {

      console.log("saveeeeee", response)
      if (response.data.success) {
        console.log("registration response=>", response)
        setToggleAcceptPopupOpen("2");
        setAlertImg(checkImg);
        setAlertTitle("Successfully Accepted")
        setAlertMessage("Thank you so much for your business, We thank you to let us earn your business.")
        // getbidsList();

      } else {
        const { data } = response;
        setToggleAcceptPopupOpen("2");
        setAlertImg(errorImg);
        console.log("error response=>", data.error.err)
        setAlertMessage(data.error.err)

      }

      //   console.log("registration response=>", response)
      //   setToggleAcceptPopupOpen(false);
      //   setAlertImg(checkImg);
      //   setAlertTitle("Successfully Accepted")
      //   setAlertMessage("Thank you so much for your business, We thank you to let us earn your business.")

      // else {
      //   const { data } = response;
      //   setToggleAcceptPopupOpen(false);
      //   setAlertImg(errorImg);
      //   console.log("error response=>", data.error.err)
      //   setAlertMessage(data.error.err)

      // }

    }).catch(function (error) {
      if (error.response) {
        setErrors(error.response.data.error)
        setErrorFlag(true)

      }
    });
  }

  return (


    <div>
      {carAcceptFlag ?
        <div>



          <>
            {errorFlag === true ? <ErrorPopup error={errors} /> :


              <Modal show={true} onHide={props.toggle} size="xl" centered>
                <Modal.Header className='Terms-login'>
                  <h2 > Buyer Bids</h2>
                </Modal.Header>
                {loading ? <Loading /> :
                  <Modal.Body>
                    <div style={{ overflowX: 'auto' }}>
                      <table class="bidinfo-table">
                        <thead className='Bidlist' >
                          <tr>
                            <th className="th_id">Buyer #</th>
                            <th className="th_id">Dealer Name</th>
                            <th className="th_id">Buyer Name</th>
                            <th className="th_name">Amount</th>
                            <th className="th_action action-right-fix-header">Action</th>
                          </tr>
                        </thead>
                        {bidLists.length > 0 ? bidLists.map((item, index) =>
                          <tr>
                            <td>{item.buyer_id}</td>
                            <td>{item.dealer_name}</td>
                            <td>{item.buyername}</td>
                            <td>{item.bid}</td>
                            <td className='action-right-fix-list' >
                              {item?.status == "sold" ?
                                <Button className="ant-btndisable" disable /* onClick={() => onHandleEdit(item)} */> Accept</Button> :

                                <Button className="ant-btn1" onClick={() => { setcarAcceptFlag(false); handleData(item.buyer_id, item.buyer_dealer_id, item.bid, item.transportation_charge) }} /* onClick={() => onHandleEdit(item)} */> Accept</Button>}
                            </td>

                          </tr>
                        ) :
                          <tr>
                            <td colSpan="5" className="text-center bit-list">
                              <p>No Data Found</p>
                            </td>
                          </tr>
                        }
                      </table>
                    </div>
                    <div class="col-md-12 inactivebtns">
                      <button className="cta-btns" onClick={props.toggle}>Cancel</button>
                    </div>
                  </Modal.Body>
                }
              </Modal>
            }
          </>

        </div> :

        <div>

          {toggleAcceptPopupOpen=="1" ? (
            <Modal show={true} onHide={props.toggle} centered >
              <Modal.Header className='Terms-login'>
                <h2 className="title">Accept confirmation</h2>
              </Modal.Header>
              <Modal.Body>
                <p className="deletemsg"> Are you sure wants to accept please confirm</p>
                <div class="col-md-12">
                  <p className="deletemsg">{alertmessage}</p>
                  <div class="col-md-12 inactivebtns">
                    <button className="cta-btns" onClick={props.toggle}>Cancel</button>    <button className="cta-btns" onClick={handleAccepts}>Ok</button>
                  </div>

                </div>
              </Modal.Body>
            </Modal>) :
            toggleAcceptPopupOpen=="2" ? 
            (
              <Modal show={true} onHide={props.toggle} centered >
                <Modal.Header className='Terms-login'>
                  <h2 className="title">{alerttitle}</h2>
                </Modal.Header>
                <Modal.Body>
                  <div className="CommonModalbody">
                    <img className={alertimg === "" ? "successImg " : "errorImg"} src={alertimg} />
                  </div>
                  <div class="col-md-12">
                    <p className="deletemsg">{alertmessage}</p>
                    <div class="col-md-12 inactivebtns">
                      <button className="cta-btns" onClick={()=>soldredirectpage()}>ok</button>
                    </div>
                  </div>
                </Modal.Body>
              </Modal>
            ):""
            }

        </div>
      }
    </div >
  )
}

export default SealedBid;